import { postJSON } from './http';

export type BizChatAskParams = {
  business_slug?: string;   // optional; falls back to localStorage if absent
  question: string;
  window?: 3 | 6 | 9;       // trailing months
};

export type BizChatAskResponse = {
  answer: string;
  meta?: Record<string, unknown>;
};

export async function askBizChat(params: BizChatAskParams): Promise<BizChatAskResponse> {
  const business =
    params.business_slug ||
    (() => {
      try {
        const raw = localStorage.getItem('selected_business');
        return raw ? JSON.parse(raw).slug : undefined;
      } catch { return undefined; }
    })();

  return postJSON<BizChatAskResponse>('/bizchat/ask', {
    business_slug: business,
    question: params.question,
    window: params.window ?? 3,
  });
}
